import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  adjustmentContainer: {
    gap: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  adjustmentTitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  adjustmentValue: {
    width: 32,
    height: 32,
    paddingVertical: 5,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.cement,
  },
  ctaButtonSecondary: {
    paddingVertical: 9,
    minHeight: 32,
  },
  ctaText: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 21,
  },
});
